import React from "react";
import TrustedByForm from "./TrustedByForm";

const AddTrustedBy = () => {
  return (
    <>
      <TrustedByForm action="Add" />
    </>
  );
};

export default AddTrustedBy;


